/** Mirrors the appearance and accessibility preferences onto the document root so plain CSS can honour them without every component subscribing. */
import { useEffect, useSyncExternalStore } from 'react';
import { getPreferencesSnapshot, subscribePreferences } from './preferencesStore';

export function usePreferenceEffects(): { reduceMotion: boolean } {
  const { appearance, accessibility } = useSyncExternalStore(subscribePreferences, getPreferencesSnapshot, getPreferencesSnapshot);
  const { density } = appearance;
  const { reduceMotion, underlineLinks } = accessibility;

  useEffect(() => {
    document.documentElement.dataset.density = density;
    return () => {
      delete document.documentElement.dataset.density;
    };
  }, [density]);

  useEffect(() => {
    document.documentElement.classList.toggle('qs-reduce-motion', reduceMotion);
    return () => document.documentElement.classList.remove('qs-reduce-motion');
  }, [reduceMotion]);

  useEffect(() => {
    document.documentElement.classList.toggle('qs-underline-links', underlineLinks);
    return () => document.documentElement.classList.remove('qs-underline-links');
  }, [underlineLinks]);

  return { reduceMotion };
}
